import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Router } from "@angular/router";

@Component({
  selector: "art-item-go-to-detail-button",
  imports: [CommonModule, MatIconModule, MatButtonModule, MatTooltipModule],
  template: `
    <button
      class="hover:text-green-500"
      (click)="goToItemDetail(itemId)"
      mat-icon-button
      type="button"
      [matTooltip]="tooltip"
    >
      <mat-icon [svgIcon]="'mat:' + icon"></mat-icon>
    </button>
  `,
})
export class ItemGoToDetailButtonComponent implements OnInit {
  /** Determines the button mode: "go" navigates to detail, "edit" navigates to edit. */
  @Input() type: "go" | "edit" = "go";
  /** ID of the item to navigate to. */
  @Input() itemId: string;
  /** Emitted after navigation completes, so the parent can react (e.g. close a dialog). */
  @Output() navigated = new EventEmitter<void>();

  tooltip = "Přejít na detail díla";
  icon = "arrow_forward";

  constructor(private router: Router) {}

  ngOnInit(): void {
    if (this.type === "edit") {
      this.tooltip = "Editovat dílo";
      this.icon = "edit";
    }
  }

  /** Navigates to the item detail page and emits the navigated event. */
  async goToItemDetail(id: string) {
    await this.router.navigate(["/item", id]);
    this.navigated.emit();
  }
}
